export default [
  {
    path: '/main/stock-alerts',
    meta: {
      tag: 'list_alerts',
      name: 'Alertas',
      breadcrumb: 'Alertas'
    },
    component: () => import(/* webpackChunkName: "alert-list" */ '@/views/main/settings/stock-registers/alerts/Index.vue'),
    children: [
      {
        path: '',
        name: 'listalerts',
        meta: {
          tag: 'list_alerts',
          name: 'Alertas',
          menu: 'settings'
        },
        component: () => import(/* webpackChunkName: "alert-list" */ '@/views/main/settings/stock-registers/alerts/List.vue')
      },
      {
        path: '/main/stock-alert/add',
        name: 'addalert',
        meta: {
          tag: 'add_alert',
          name: 'Adicionar | Alerta',
          breadcrumb: 'Adicionar Alerta',
          menu: 'settings'
        },
        component: () => import(/* webpackChunkName: "alert-add" */ '@/views/main/settings/stock-registers/alerts/Add.vue')
      },
      {
        path: '/main/stock-alert/:id',
        name: 'editalert',
        meta: {
          tag: 'edit_alert',
          name: 'Editar | Alerta',
          breadcrumb: 'Editar Alerta',
          menu: 'settings'
        },
        component: () => import(/* webpackChunkName: "alert-edit" */ '@/views/main/settings/stock-registers/alerts/Edit.vue')
      }
    ]
  }
]